<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div class="wf-flex wf-flex-wrap wf-mb-6 wf--mx-2" v-for="(posts, index) in chunkedPosts" :key="index">
      <div class="wf-px-2" :class="widthClasses" v-for="post in posts" :key="post.id">
        <div
          :class="elementClasses(classes('classes'), [...classes('customClasses'), 'wf-overflow-hidden'])"
          :style="elementStyles(styles('styles'))"
        >
          <div
            v-show="content.showImage"
            class="wf-h-48 wf-full wf-bg-center wf-bg-cover"
            style="background-image: url('https://images.unsplash.com/photo-1593058097945-4c6c8d09a6b1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2551&q=80')"
          ></div>
          <div :class="elementClasses(classes('contentClasses'))" :style="elementStyles(styles('contentStyles'))">
            <draggable
              :group="`blog_post_${post.id}`"
              v-model="blocks"
              handle=".blog-posts-block-handle"
            >
              <component
                v-for="block in blocks"
                :is="block.component"
                :key="block.component"
                v-show="block.show"
                :containerClasses="block.containerClasses"
                :classes="block.classes"
                :styles="block.styles"
                :value="postValue(post.id, block.component)"
              />
            </draggable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import moment from 'moment'
  import draggable from 'vuedraggable'
  import BlogPostsDate from './BlogPostsDate'
  import BlogPostsTags from './BlogPostsTags'
  import BlogPostsTitle from './BlogPostsTitle'
  import BlogPostsAuthor from './BlogPostsAuthor'
  import BlogPostsReadMore from './BlogPostsReadMore'
  import BlogPostsCategories from './BlogPostsCategories'
  import BlogPostsDescription from './BlogPostsDescription'
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({
    components: {draggable, BlogPostsDate, BlogPostsTags, BlogPostsTitle, BlogPostsAuthor, BlogPostsReadMore, BlogPostsCategories, BlogPostsDescription},
    data() {
      return {
        posts: []
      }
    },
    created() {
      this.getPosts()
    },
    watch: {
      postsIds() {
        this.getPosts()
      },
      filterBy() {
        this.getPosts()
      },
      filterId() {
        this.getPosts()
      },
      orderBy() {
        this.getPosts()
      },
      sortBy() {
        this.getPosts()
      },
      quantity() {
        this.getPosts()
      }
    },
    computed: {
      componentBlocks() {
        return {
          BlogPostsCategories: {
            component: 'BlogPostsCategories',
            show: this.content.showCategories,
            classes: this.elementClasses(this.classes('categoriesClasses'), ['wf-inline-block', 'wf-mb-1']),
            styles: this.elementStyles(this.styles('categoriesStyles')),
          },
          BlogPostsTitle: {
            component: 'BlogPostsTitle',
            show: this.content.showTitle,
            classes: this.elementClasses(this.classes('titleClasses')),
            styles: this.elementStyles(this.styles('titleStyles')),
          },
          BlogPostsDescription: {
            component: 'BlogPostsDescription',
            show: this.content.showDescription,
            classes: this.elementClasses(this.classes('descriptionClasses')),
            styles: this.elementStyles(this.styles('descriptionStyles')),
          },
          BlogPostsAuthor: {
            component: 'BlogPostsAuthor',
            show: this.content.showAuthor,
            classes: this.elementClasses(this.classes('authorClasses')),
            styles: this.elementStyles(this.styles('authorStyles')),
          },
          BlogPostsDate: {
            component: 'BlogPostsDate',
            show: this.content.showPublishedDate,
            classes: this.elementClasses(this.classes('dateClasses')),
            styles: this.elementStyles(this.styles('dateStyles')),
          },
          BlogPostsTags: {
            component: 'BlogPostsTags',
            show: this.content.showTags,
            classes: this.elementClasses(this.classes('tagsClasses'), ['wf-inline-block']),
            styles: this.elementStyles(this.styles('tagsStyles')),
          },
          BlogPostsReadMore: {
            component: 'BlogPostsReadMore',
            show: this.content.showReadMore,
            containerClasses: this.elementClasses(this.classes('readMoreContainerClasses')),
            classes: this.elementClasses(this.classes('readMoreClasses'), ['wf-inline-block']),
            styles: this.elementStyles(this.styles('readMoreStyles')),
          },
        }
      },
      blocks: {
        get() {
          return this.content.blocks.map(block => this.componentBlocks[block])
        },
        set(value) {
          let blocks = value.map(valueBlock => valueBlock.component)
          this.addToObject(this.module, {blocks}, 'content')
        }
      },
      widthClasses() {
        if (this.content.postsGrid == 6) {
          return 'wf-w-1/6'
        }
        
        if (this.content.postsGrid == 5) {
          return 'wf-w-1/5'
        }

        if (this.content.postsGrid == 4) {
          return 'wf-w-1/4'
        }

        if (this.content.postsGrid == 3) {
          return 'wf-w-1/3'
        }

        if (this.content.postsGrid == 2) {
          return 'wf-w-1/2'
        }

        return 'wf-w-full'
      },
      chunkedPosts() {
        return _.chunk(this.posts, this.content.postsGrid)
      },
      postsIds() {
        return this.content.filter.filterPostsIds
      },
      filterBy() {
        return this.content.filter.filterBy
      },
      filterId() {
        return this.content.filter.filterId
      },
      orderBy() {
        return this.content.filter.filterOrderBy
      },
      sortBy() {
        return this.content.filter.filterSortBy
      },
      quantity() {
        return this.content.filter.filterQuantity
      },
    },
    methods: {
      postValue(postId, block) {
        let post = this.posts.find(post => post.id == postId)
        if (block == 'BlogPostsTags') {
          return post.tags
        }
        if (block == 'BlogPostsReadMore') {
          return this.content.readMoreText
        }
        if (block == 'BlogPostsCategories') {
          return post.categories
        }
        if (block == 'BlogPostsAuthor') {
          return `${post.user.first_name} ${post.user.last_name}`
        }
        if (block == 'BlogPostsTitle') {
          return post.title
        }
        if (block == 'BlogPostsDescription') {
          return post.summary
        }
        if (block == 'BlogPostsDate') {
          return this.readableDate(post.published_at)
        }
      },
      readableDate(date) {
        return moment(date).format('MMM Do, YYYY')
      },
      getPosts() {
        axios.get(`${process.env.VUE_APP_BACKEND_URL}/editor/api/posts`, {
          params: {
            filter_id: this.filterId,
            filter_by: this.filterBy,
            sort_by: this.sortBy,
            order_by: this.orderBy,
            posts_ids: this.postsIds,
            quantity: this.quantity
          }
        }).then(({data}) => this.posts = data.data.posts)
      },
    }
  })
</script>